import http from 'src/services/httpService';

export const CRITERIOS_PUBLICO_INTERESSADO_PADRAO = {
  tempoMinimoCargoDias: null,
  tempoMinimoEmpresaDias: null,
  cargos: [],
  areas: [],
  considerarAreasSubordinadas: false,
  colaboradores: [],
};

export async function obterPublicoInteressadoDocumento(model) {
  if (model.agrupador) return {};

  const response = await http.post('/DocumentoPublicoInteressado/Obter', {
    documentoId: model.id,
  });

  return { criteriosPublicoInteressado: response.data };
}

export async function salvarPublicoInteressadoDocumento(savedModel, model) {
  if (savedModel.agrupador ?? model.agrupador) return {};

  const criterios = {
    ...CRITERIOS_PUBLICO_INTERESSADO_PADRAO,
    ...model.criteriosPublicoInteressado,
  };

  await http.post('/DocumentoPublicoInteressado/Salvar', {
    documentoId: savedModel.id,
    criterios,
  });

  return { criteriosPublicoInteressado: criterios };
}
